import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class InvalidTaxpayerSurnameError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.company.validation.taxpayer-surname.not-empty');
    }
}
